// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__eCYsY","content":"RecentSearches_content__243cT"};